// extracted by mini-css-extract-plugin
export var button = "_cb-4";
export var hasDarkBackground = "_cb-7";
export var hasLightBackground = "_cb-6";
export var iconWrapper = "_cb-0";
export var large = "_cb-2";
export var medium = "_cb-1";
export var small = "_cb-5";
export var xsmall = "_cb-3";